import { ColumnsType } from "antd/es/table";
import { useMemo } from "react";
import { useDefaultPaymentHistoryColumns } from "../../../../../../../lib/hooks/useDefaultPaymentHistoryColumns";
import { DATE_FORMAT } from "../../../../../../../lib/constants";
import dayjs from "dayjs";
import { TableActions } from "../components/TableActions";

type TTableColumnsProps = {
  setPaymentId: React.Dispatch<React.SetStateAction<string | null | undefined>>;
  reloadData: () => void;
  setOpenEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  setIsActionsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  isActionsDisabled: boolean;
};

export const useGetTableColumns = ({
  setPaymentId,
  reloadData,
  setOpenEditMode,
  setIsActionsDisabled,
  isActionsDisabled,
}: TTableColumnsProps) => {
  const { columns: defaultColumns } = useDefaultPaymentHistoryColumns();

  const columns: ColumnsType<any> = useMemo(
    () => [
      ...defaultColumns,
      {
        title: "Last Updated",
        dataIndex: "lastModified",
        key: "lastModified",
        width: 174,
        ellipsis: true,
        render: (value: string | Date, record: any) => {
          const { lastModifiedBy } = record;

          const lastUpdatedBy = lastModifiedBy ? ` by ${lastModifiedBy}` : "";

          return (
            <span>
              {dayjs(value).format(DATE_FORMAT)}
              {lastUpdatedBy}
            </span>
          );
        },
      },
      {
        key: "actions",
        width: 84,
        fixed: "right",
        render: (_: any, record: any) => (
          <TableActions
            id={record.id}
            isActionsDisabled={isActionsDisabled}
            setPaymentId={setPaymentId}
            setIsActionsDisabled={setIsActionsDisabled}
            setOpenEditMode={setOpenEditMode}
            reloadData={reloadData}
          />
        ),
      },
    ],
    [
      defaultColumns,
      isActionsDisabled,
      reloadData,
      setIsActionsDisabled,
      setOpenEditMode,
      setPaymentId,
    ],
  );

  return { columns };
};
